/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var BookmarkIcon20Solid = forwardRef('BookmarkIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M16 16.795V5a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3v11.795a1.5 1.5 0 0 0 2.294 1.272l3.412-2.13a1.5 1.5 0 0 1 1.588 0l3.412 2.13A1.5 1.5 0 0 0 16 16.795Z" })));
});
